import { Box } from "@chakra-ui/react";


export default function ReactIconDisplay(props) {
	const { reactIcon, color, fontWeight, fontSize } = props;
	
	return (
		<Box as={reactIcon} color={color} boxSize={fontWeight} fontSize={fontSize}/>
	)
}
